import { FaWhatsapp, FaTelegram, FaXTwitter, FaFacebook, FaInstagram, FaTiktok, FaSnapchat } from "react-icons/fa6";
import { toast } from "sonner";
import { useI18n } from "@/context/I18nContext";

const enc = encodeURIComponent;

const PLATFORMS = [
  { id: "whatsapp", Icon: FaWhatsapp, color: "#25D366", intent: ({ text }) => `https://wa.me/?text=${enc(text)}` },
  { id: "telegram", Icon: FaTelegram, color: "#229ED9", intent: ({ text, link }) => `https://t.me/share/url?url=${enc(link)}&text=${enc(text.replace(link, "").trim())}` },
  { id: "snapchat", Icon: FaSnapchat, color: "#F7D400", dark: true, intent: ({ link }) => `https://www.snapchat.com/scan?attachmentUrl=${enc(link)}` },
  { id: "instagram", Icon: FaInstagram, color: "#E1306C", site: "https://www.instagram.com/" },
  { id: "tiktok", Icon: FaTiktok, color: "#111111", site: "https://www.tiktok.com/upload" },
  { id: "x", Icon: FaXTwitter, color: "#000000", intent: ({ text }) => `https://twitter.com/intent/tweet?text=${enc(text)}` },
  { id: "facebook", Icon: FaFacebook, color: "#1877F2", intent: ({ link, text }) => `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}&quote=${enc(text)}` },
];

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
}

export const SocialShareRow = ({ text, link, getImage, title }) => {
  const { t } = useI18n();

  const nativeShare = async () => {
    const payload = { text, title };
    if (getImage) {
      const blob = await getImage();
      const file = new File([blob], "breeders-tracking-app.png", { type: "image/png" });
      if (navigator.canShare?.({ files: [file] })) payload.files = [file];
      else return false;
    } else if (!navigator.share) {
      return false;
    }
    try { await navigator.share(payload); } catch (e) { if (e?.name !== "AbortError") return false; }
    return true;
  };

  const go = async (p) => {
    if (await nativeShare()) return;
    if (getImage) {
      const blob = await getImage();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "breeders-tracking-app.png";
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    }
    await copyText(text);
    toast.success(t(getImage ? "share.desktop_hint_img" : "share.desktop_hint"));
    window.open(p.intent ? p.intent({ text, link }) : p.site, "_blank", "noopener");
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="social-share-row">
      {PLATFORMS.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => go(p)}
          title={p.id}
          aria-label={p.id}
          className="w-10 h-10 rounded-full flex items-center justify-center text-white shadow-sm hover:scale-110 transition-transform"
          style={{ background: p.color, color: p.dark ? "#111" : "#fff" }}
          data-testid={`share-${p.id}`}
        >
          <p.Icon className="w-5 h-5" />
        </button>
      ))}
    </div>
  );
};
